import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Circular from '../Circular/Circular';
import Button from "components/CustomButtons/Button.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';


const useStyles = theme => ({
    iconView : {
      color: "gray !important"
    },
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            width: 200,
            marginLeft: "10px !important"
        },
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    },
    dialog: {
        '& .MuiPaper-root':{
            margin: theme.spacing(1),
            width: 250,
            height: 200  
        }
    }
  });

class Date extends Component {
    constructor(props) {
        super(props);
        this.handleDefine = this.handleDefine.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDateChangeFrom = this.handleDateChangeFrom.bind(this);
        this.handleDateChangeTo = this.handleDateChangeTo.bind(this);

        this.state = {
            dateFrom: null,
            dateTo: null
        }
    }
        
    handleDefine = () => {
        let { dateFrom, dateTo } = this.state;
        this.props.onChangeDate(dateFrom, dateTo);
        this.handleClose()
    };

    handleClose = () => {
        this.props.onChange(false);
    };

    handleDateChangeFrom(e) {
        this.setState({dateFrom: e});
    };

    handleDateChangeTo(e) {
        this.setState({dateTo: e});
    };

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Dialog className={(this.state.waiting) ? classes.dialog : null}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Defina o Período"}</DialogTitle>
                    <DialogContent className={classes.root}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid container justify="space-around">
                                <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="normal"
                                id="from"
                                label="Data inicial"
                                value={this.state.dateFrom}
                                onChange={this.handleDateChangeFrom}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                />
                                <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="normal"
                                id="to"
                                label="Data final"
                                value={this.state.dateTo}
                                onChange={this.handleDateChangeTo}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                />  
                            </Grid>
                        </MuiPickersUtilsProvider>
                    </DialogContent>
                    <DialogActions>
                    {(this.state.waiting) ? null :
                    <div><Button onClick={this.handleClose} color="default">
                        Voltar
                    </Button>
                    <Button onClick={this.handleDefine} color="primary" autoFocus>
                        Definir
                    </Button></div>}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default withStyles(useStyles)(Date);